// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@rails/activestorage").start();

require("./modules/chief_form_idle.js");

import "jquery";
import "../channels"; // ActionCable consumer + channel autoload
import { subscribeAgentStream } from "../channels/agent_stream_channel";

// Expose helper globally for inline scripts to use without dynamic import
if (!window.AgentStream) window.AgentStream = {};
window.AgentStream.subscribeAgentStream = subscribeAgentStream;
import "select2";
import "../stylesheets/select2";

// Inicializa o Select2 com Ajax
document.addEventListener("DOMContentLoaded", function () {
  $(".select2-ajax").each(function () {
    var $select = $(this);
    var url = $select.data("url");
    var placeholder = $select.data("placeholder");
    var selected = $select.data("selected");

    $select.select2({
      theme: "bootstrap4",
      width: "100%",
      placeholder: placeholder,
      allowClear: true,
      ajax: {
        url: url,
        dataType: "json",
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data.results,
          };
        },
        cache: true,
      },
    });

    // Se houver um valor selecionado, adiciona a opção inicial
    if (selected) {
      var option = new Option(selected.text, selected.id, true, true);
      $select.append(option).trigger("change");
    }
  });
});

require("@popperjs/core");
import { Tooltip, Popover } from "bootstrap";
require("trix");
require("jquery.maskedinput");
import "typicons.font";
import "./modernizer.min.js";
import "./multiple-select.js"; // https://multiple-select.wenzhixin.net.cn/en/
import "./multi-select.js";
import AOS from "aos";
import "@fortawesome/fontawesome-free/css/all";
require("bootstrap-select");
import "bootstrap-select/dist/css/bootstrap-select";
import "./modules/jquery-maskmoney.js";
window.bootstrap = require("bootstrap");
import "jquery-mask-plugin";
import "./modules/masks.js";
import "./modules/readmore.js";
require("perfect-scrollbar");
import PerfectScrollbar from "perfect-scrollbar";
import "./jquery.Jcrop.js";
import "./user_avatar.js";
import "./nps_modal.js";
import "./modules/jquery.growl.js";
import "./modules/notification.js";
import "./ibge_locations.js";
import "./chief_submit_helper.js";
require("flatpickr");
import Sortable from "sortablejs";

$(document).ready(function () {
  AOS.init();
  $.fn.selectpicker.Constructor.BootstrapVersion = "5";

  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
  });

  const ps = new PerfectScrollbar(".app-sidebar", {
    useBothWheelAxes: true,
    suppressScrollX: true,
    suppressScrollY: false,
  });

  $(".cpf").mask("000.000.000-00");
  $(".birth").mask("00/00/0000");
  $(".card-number").mask("0000 0000 0000 0000", { reverse: false });
  $(".cvv-number").mask("0000");
  $(".zipcode").mask("00000-000");

  const Pt = require("flatpickr/dist/l10n/pt.js").default.pt;
  flatpickr.localize(Pt);

  $(".datetimepicker").flatpickr({
    enableTime: true,
    altInput: true,
    altFormat: "d/m/Y H:i",
    dateFormat: "Y-m-d H:i",
  });
  $(".datepicker").flatpickr({
    enableTime: false,
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "Y-m-d",
  });
  $(".datepicker-range").flatpickr({
    mode: "range",
    dateFormat: "d/m/Y",
    locale: { rangeSeparator: " até " },
  });

  $("#order_splits").on("change", function (event) {
    return $.growl.warning({
      title: "",
      message: "Carrinho atualizado",
    });
  });

  $("#order_coupon").on("change", function (event) {
    return $.growl.warning({
      title: "",
      message: "Carrinho atualizado",
    });
  });
});
